import { ref } from "vue";
import { useStore } from "vuex";

import { getObjectKeys } from "@/helpers/common";
import { SERVICE_OPTIONS } from "@/helpers/constants/experian";
import { usePromiseWrapper } from "@/hooks/common";

export const useExperianService = (provider: keyof typeof SERVICE_OPTIONS) => {
  const { dispatch } = useStore();

  const allServiceOptions = getObjectKeys(SERVICE_OPTIONS[provider]);
  const selectedOptions = ref(allServiceOptions);

  const { fetchWrapper: enrichService, loading: isLoading } = usePromiseWrapper(
    async () => {
      const options = allServiceOptions.reduce(
        (res: Record<string, boolean>, curr) => {
          res[curr] = selectedOptions.value.includes(curr);
          return res;
        },
        {}
      );
      await dispatch("applications/enrichApp", {
        provider,
        options,
      });
    }
  );

  return { selectedOptions, enrichService, isLoading };
};
